import { useMutation } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

type ChangePasswordPayload = {
  userId: string;
  currentPassword: string;
  newPassword: string;
};

type ChangePasswordResponse = {
  message: string;
};

const changeUserPassword = async ({
  userId,
  currentPassword,
  newPassword,
}: ChangePasswordPayload): Promise<ChangePasswordResponse> => {
  const { data } = await customAxios.post<ChangePasswordResponse>(
    `/users/${userId}/change-password`,
    { currentPassword, newPassword }
  );
  return data;
};

export const useChangeUserPassword = () =>
  useMutation({
    mutationFn: changeUserPassword,
  });
